// extracted by mini-css-extract-plugin
export default {"btncito":"ShoppingCart_btncito__oc7Qi","cart":"ShoppingCart_cart__aQA42"};